import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "disabled", "connectedLeft", "connectedRight", "error", "helpText", "inverse", "onBlur", "onFocus", "prefix", "readOnly", "success", "suffix", "value", "warning", "width", "noInputStyling"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import cx from 'classnames';
import React, { forwardRef, useState } from 'react';
import Box, { omitBoxProps, pickBoxProps } from '../box';
import ValidationText from '../validationText';
import InputBase from './InputBase';
import theme from './theme.css';
var SingleLineInputBase = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var className = _ref.className,
    disabled = _ref.disabled,
    connectedLeft = _ref.connectedLeft,
    connectedRight = _ref.connectedRight,
    error = _ref.error,
    helpText = _ref.helpText,
    inverse = _ref.inverse,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    prefix = _ref.prefix,
    readOnly = _ref.readOnly,
    success = _ref.success,
    suffix = _ref.suffix,
    value = _ref.value,
    warning = _ref.warning,
    width = _ref.width,
    noInputStyling = _ref.noInputStyling,
    others = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    inputHasFocus = _useState2[0],
    setInputHasFocus = _useState2[1];
  var handleBlur = function handleBlur(event) {
    setInputHasFocus(false);
    onBlur && onBlur(event);
  };
  var handleFocus = function handleFocus(event) {
    setInputHasFocus(true);
    onFocus && onFocus(event);
  };
  var renderOneOrMultipleElements = function renderOneOrMultipleElements(prop) {
    if (Array.isArray(prop)) {
      return prop.map(function (element, index) {
        return /*#__PURE__*/React.cloneElement(element, {
          key: index
        });
      });
    }
    return prop;
  };
  var classNames = cx(theme['wrapper'], _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, theme['has-focus'], inputHasFocus), theme['has-error'], error), theme['has-success'], success), theme['has-warning'], warning), theme['has-connected-left'], connectedLeft), theme['has-connected-right'], connectedRight), theme['is-disabled'], disabled), theme['is-inverse'], inverse), theme['is-read-only'], readOnly), className);
  var boxProps = pickBoxProps(others);
  var inputProps = _objectSpread({
    ref: forwardedRef,
    disabled: disabled,
    inverse: inverse,
    onBlur: handleBlur,
    onFocus: handleFocus,
    readOnly: readOnly,
    value: value
  }, omitBoxProps(others));
  return /*#__PURE__*/React.createElement(Box, _extends({
    className: classNames
  }, boxProps), /*#__PURE__*/React.createElement("div", {
    className: cx(theme['input-wrapper'], noInputStyling && theme['is-input-disabled'])
  }, connectedLeft, /*#__PURE__*/React.createElement("div", {
    className: theme['input-inner-wrapper'],
    style: {
      width: width,
      flex: width && '0 1 auto'
    }
  }, prefix && /*#__PURE__*/React.createElement("div", {
    className: theme['prefix-wrapper']
  }, renderOneOrMultipleElements(prefix)), /*#__PURE__*/React.createElement(InputBase, inputProps), suffix && /*#__PURE__*/React.createElement("div", {
    className: theme['suffix-wrapper']
  }, renderOneOrMultipleElements(suffix))), connectedRight), /*#__PURE__*/React.createElement(ValidationText, {
    error: error,
    help: helpText,
    inverse: inverse,
    success: success,
    warning: warning
  }));
});
SingleLineInputBase.displayName = 'SingleLineInputBase';
export default SingleLineInputBase;